import Message from 'kpc/components/message';

const errorMsgDuration = 10 * 1000

export default {
    send(message:any, type:any) {
        if (type === 'success') {
            Message.success(message);
        } else if (type === 'info') {
            Message.info(message);
        } else {
            Message.error(message, errorMsgDuration);
        }
    }
};
